import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiTableCell from '@material-ui/core/TableCell';

import {
  tableHead, tableBody,
} from '../../../src/themes/colors';

const styles = theme => ({
  root: {
    color: tableBody,
    fontSize: '0.75rem',
    lineHeight: '14.63px',
    letterSpacing: '-0.2px',
    fontFamily: theme.typography.fontFamily,
    verticalAlign: 'middle',
  },
  head: {
    fontSize: '0.625rem',
    color: tableHead,
    fontWeight: 600,
    '&.sortable': {
      position: 'relative',
      cursor: 'pointer',
      transition: '0.3s ease-in-out',
    },
  },
  paddingCheckbox: {
    padding: '0 40px 0 1rem',
  },
});
const TableCell = (props) => {
  const { classes } = props;
  return (
    <MuiTableCell
      classes={{
        root: classes.root,
        head: classes.head,
        paddingCheckbox: classes.paddingCheckbox,
      }}
      {...props}
      style={props.alignRight ? {
        textAlign: 'right',
      } : undefined}
    >
      {props.children}
    </MuiTableCell>
  );
};

export default withStyles(styles)(TableCell);
